<mat-progress-bar
  appPreloader
  mode="indeterminate"
  color="accent"
  class="position-absolute"
  hidden
></mat-progress-bar>
<div class="page-auth">
  <div class="main-body">
    <app-auth-card [wide]="this.isWideCard">
      <router-outlet #outlet="outlet"></router-outlet>
    </app-auth-card>
  </div>
</div>
